<template>
    <el-table :data="data" :default-sort="{ prop: ORDERS.fields.createdAt, order: 'descending' }" class="w-100">
        <el-table-column label="Order Id" prop="id"> </el-table-column>
        <el-table-column label="Created At" sortable prop="createdAt">
            <template slot-scope="scope">
                {{ `${getCreatedDate(scope.row[ORDERS.fields.createdAt])}` }}
            </template>
        </el-table-column>
        <el-table-column label="Last Action">
            <template slot-scope="scope">
                {{ scope.row[ORDERS.fields.orderStep][scope.row[ORDERS.fields.lastOrderStepActionId]][ORDERS.orderStep.action] }}
            </template>
        </el-table-column>
        <el-table-column :prop="`storeProfile.${STORE_PROFILES.fields.name}`" label="Store"> </el-table-column>
        <el-table-column align="right">
            <template slot-scope="scope">
                <router-link :to="{ path: `/portal/orders/${scope.row.id}` }" class="btn btn-sm btn-primary">
                    Open
                </router-link>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import { ORDERS, STORE_PROFILES } from 'db'
export default {
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            ORDERS,
            STORE_PROFILES
        }
    },
    methods: {
        getCreatedDate(date) {
            return new Date(date).toLocaleString('en-US', {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.el-table table .btn {
    margin: 0 5px;
}
</style>
